<script lang="ts">
    import Link from "@frontend/Components/Link.svelte";
    import { RefreshMe, TOKEN_STORAGE_KEY } from "@frontend/user";
    import { onMount } from "svelte";
    import { translate, currentLanguage } from "../Translator";
</script>

<div class="sidebar-menu">
    <div class="menu-scroll-container">
        <div class="menu-section">
            <Link href="#/UserPerfil" class="item mini profile-link">
                <div class="icon-container">
                    <i class="user circle icon"></i>
                </div>
                <span>{$translate('Profile')}</span>
            </Link>
            <Link href="#/Transaction" class="item mini">
                <div class="icon-container">
                    <i class="wallet icon"></i>
                </div>
                <span>{ $translate('Transactions')}</span>
            </Link>
            <Link href="#/SumReport" class="item mini">
                <div class="icon-container">
                    <i class="calculator icon"></i>
                </div>
                <span>{ $translate('Sums')}</span>
            </Link>
                     <Link href="#/PromotionalCredits" class="item mini">
            <div class="icon-container">
                <i class="money bill wave icon"></i>
            </div>
            <span>{ $translate('Campaigns')}</span>
        </Link>
            <Link href="#/GameRoundList" class="item mini">
                <div class="icon-container">
                    <i class="history icon"></i>
                </div>
                <span>{ $translate('Rounds')}</span>
            </Link>
            <Link href="#/GameServerList" class="item mini">
                <div class="icon-container">
                    <i class="server icon"></i>
                </div> 
                <span> {$translate('Game Servers')}</span>
            </Link>
                 <Link href="#/BannersList" class="item mini">
                <div class="icon-container">
                    <i class="photo video icon"></i>
                </div> 
                <span>{ $translate('Banners')}</span>
            </Link>
            <Link href="#/GamesList" class="item mini">
                <div class="icon-container">
                    <i class="chess icon"></i>
                </div>
                <span>{ $translate('Games')}</span>
            </Link>
            <Link href="#/AdminList" class="item mini">
                <div class="icon-container">
                    <i class="user shield icon"></i>
                </div>
                <span>{ $translate('Administrators')}</span>
            </Link>   
            <Link href="#/CashierList" class="item mini">
                <div class="icon-container">
                    <i class="cash register icon"></i>
                </div>
                <span>{ $translate('Cashiers')}</span>
            </Link>
            <Link href="#/UnassignedUser" class="item mini">
                <div class="icon-container">
                    <i class="user friends icon"></i>
                </div>
                <span>{ $translate('Unassigned')}</span>
            </Link>
            <Link href="#/PlayerList" class="item mini">
                <div class="icon-container">
                    <i class="user friends icon"></i>
                </div>
                <span>{ $translate('Players')}</span>
            </Link>
            <Link href="#/Groups" class="item mini">
                <div class="icon-container">
                    <i class="users icon"></i>
                </div>
                <span>{ $translate('Games Groups')}</span>
            </Link>
            <Link href="#/GroupList" class="item mini">
                <div class="icon-container">
                    <i class="users icon"></i>
                </div>
                <span>{ $translate('Groups Limits')}</span>
            </Link>
                        <Link href="#/GroupLimit" class="item mini">
                <div class="icon-container">
                    <i class="object group icon"></i>
                </div>
                <span>{ $translate('Groups Limits')}</span>
            </Link>
            <!-- <Link href="#/MachineList" class="item mini">
                <div class="icon-container">
                    <i class="desktop icon"></i>
                </div>
                <span>Machines</span>
            </Link> -->
            <!-- <Link href="#/OwnerList" class="item mini">
                <div class="icon-container">
                    <i class="user tie icon"></i>
                </div>
                <span>Owners</span>
            </Link> -->
            <!-- <Link href="#/PlayerTransactions" class="item mini">
                <div class="icon-container">
                    <i class="exchange icon"></i>
                </div>
                <span>Player Transactions</span>
            </Link> -->
            <!-- <Link href="#/UserbyTransaction" class="item mini">
                <div class="icon-container">
                    <i class="user plus icon"></i>
                </div>
                <span>Users by Transaction</span>
            </Link> -->
            <!-- <Link href="#/UserList" class="item mini">
                <div class="icon-container">
                    <i class="users icon"></i>
                </div>
                <span>All Users</span>
            </Link> -->
            <!-- <Link href="#/Shift" class="item mini">
                <div class="icon-container">
                    <i class="clock icon"></i>
                </div>
                <span>Shift Report</span>
            </Link> -->
            <!-- <Link href="#/ReportGames" class="item mini">
                <div class="icon-container">
                    <i class="chart bar icon"></i>
                </div>
                <span>Game Reports</span>
            </Link> -->
            <!-- <Link href="#/AdminReport" class="item mini">
                <div class="icon-container">
                    <i class="file alternate icon"></i>
                </div>
                <span>Admin Reports</span>
            </Link> -->
            <!-- <Link href="#/CashierReport" class="item mini">
                <div class="icon-container">
                    <i class="file text icon"></i>
                </div>
                <span>Cashier Reports</span>
            </Link> -->
            <Link href="#/user/logout" class="item mini">
                <div class="icon-container">
                    <i class="sign-out icon"></i>
                </div>
                <span>{ $translate('Logout')}</span>
            </Link>
            <!-- Espacio adicional para asegurar que el scroll funcione -->
            <div style="height: 4rem; min-height: 4rem;"></div>
        </div> 
    </div>
</div>

<style>
    .sidebar-menu {
        display: flex;
        flex-direction: column;
        height: auto;
        min-height: 100vh;
        padding-bottom: 1rem;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
        padding-top: 60px; /* Space for the absolute positioned profile */
    }

    .menu-scroll-container {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0.5rem 0;
        height: calc(100vh - 6rem);
        min-height: 0;
        padding-bottom: 6rem;
        z-index: 1001;
        position: relative;
    }

    /* Estilos para la barra de scroll - más visible */
    .menu-scroll-container::-webkit-scrollbar {
        width: 8px;
    }

    .menu-scroll-container::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        margin: 2px 0;
    }

    .menu-scroll-container::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.4);
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .menu-scroll-container::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.6);
    }

    /* Para Firefox */
    .menu-scroll-container {
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.1);
    }

    .menu-section {
        padding: 0.25rem 0;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
        position: relative;
    }

    .menu-section:last-child {
        border-bottom: none;
    }

    :global(.item.mini) {
        padding: 0.5rem 1rem !important;
        font-size: 0.9em !important;
        display: flex !important;
        align-items: center !important;
    }

    :global(.icon-container) {
        width: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.5rem;
    }

    :global(.item.mini i.icon) {
        margin: 0 !important;
    }

    :global(.item.mini:hover) {
        background-color: rgba(255,255,255,0.1) !important;
    }

    :global(.item.mini span) {
        flex: 1;
    }

    /* Asegurar que el último elemento sea completamente visible */
    .menu-section:last-child {
        margin-bottom: 3rem;
    }

    /* Estilo específico para el elemento Logout */
    :global(.item.mini[href="#/user/logout"]) {
        margin-bottom: 1rem !important;
    }

    /* Forzar que el scroll tenga suficiente contenido para moverse */
    .menu-scroll-container::after {
        content: '';
        display: block;
        height: 4rem;
        min-height: 4rem;
    }

    /* Sobrescribir estilos de Fomantic UI que puedan interferir */
    :global(.ui.vertical.menu) {
        height: 100vh !important;
        max-height: 100vh !important;
        overflow: hidden !important;
    }

    :global(.toc) {
        height: 100vh !important;
        max-height: 100vh !important;
        overflow: hidden !important;
    }

    /* Asegurar que el contenedor tenga suficiente altura para el scroll */
    :global(.ui.vertical.labeled.icon.menu) {
        height: 100vh !important;
        max-height: 100vh !important;
        overflow: hidden !important;
        z-index: 1000 !important;
        position: relative !important;
    }

    /* Asegurar que el sidebar completo tenga z-index alto */
    :global(.toc) {
        z-index: 1000 !important;
        position: fixed !important;
    }

    /* Asegurar que las tablas no se superpongan al sidebar */
    :global(.ui.table) {
        z-index: 1 !important;
        position: relative !important;
    }

    /* Asegurar que el contenido principal no se superponga al sidebar */
    :global(.article) {
        z-index: 1 !important;
        position: relative !important;
    }

    /* SUPER AGGRESSIVE profile visibility - highest priority */
    :global(.toc .ui.vertical.labeled.icon.menu .sidebar-menu .item.mini.profile-link) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    :global(.toc .ui.vertical.labeled.icon.menu .menu-section .item.mini.profile-link) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(12, 12, 12, 0.1) !important;
    }

    /* Force ALL profile links to be visible regardless of parent */
    :global([href="#/UserPerfil"]) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        z-index: 999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: rgba(255,255,255,0.1) !important;
    }

    /* ULTRA AGGRESSIVE profile visibility using global selectors */
    :global(.profile-link) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        z-index: 9999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: #1b1c1d !important;
        color: white !important;
        border: none !important;
        margin: 0 !important;
        padding: 0.5rem !important;
        border-radius: 5px !important;
        font-weight: bold !important;
        text-decoration: none !important;
    }

    /* Force profile-link to be visible in all contexts */
    :global(.item.mini.profile-link) {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        z-index: 9999 !important;
        height: auto !important;
        overflow: visible !important;
        background-color: #1b1c1d !important;
        color: white !important;
        border: none !important;
        margin: 0 !important;
        padding: 0.5rem !important;
        border-radius: 5px !important;
        font-weight: bold !important;
        text-decoration: none !important;
    }

    /* Ensure normal menu items flow properly */
    :global(.item.mini:not(.profile-link)) {
        margin-bottom: 0.1rem !important;
        padding: 0.5rem !important;
    }

    /* Ensure last menu item has extra space */
    .menu-section:last-child {
        padding-bottom: 0.5rem !important;
    }

    /* Desktop specific styles */
    @media (min-width: 769px) {
        :global(.profile-link) {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            z-index: 9999 !important;
            background-color: #1b1c1d !important;
            color: white !important;
            border: none !important;
            margin: 0 !important;
            padding: 0.5rem !important;
            border-radius: 5px !important;
            font-weight: bold !important;
            text-decoration: none !important;
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
        }

        .sidebar-menu {
            padding-top: 60px !important;
        }
    }
</style>
